import { $http } from '@/utils';

/**
 * @namespace Service
 * @class CarePlan
 * @exports Service/CarePlan
 * @description API CarePlan Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class CarePlan {
	/**
	 * @static @name list
	 * @description Get a list of referrals
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static list(payload) {
		return $http.post('care-plan/list', payload);
	}
	/**
	 * @static @name post
	 * @description Add a new care plan resource
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post('care-plan', payload);
	}
}
